// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fe975e15","732":"3457ce74"}[chunkId] + ".chunk.js";
};